import { campaignTypes } from "@campaign/campaign-types.di";
import type { CampaignFilter } from "@campaign/domain/models/campaign.model";
import { Campaigns } from "@campaign/domain/models/campaign.model";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import type { Pagination } from "@core/domain/models/pagination.model";
import { inject, injectable } from "inversify";

@injectable()
export class CampaignGetAllUseCase {
    constructor(
        @inject(campaignTypes.repositories.CampaignRepository)
        private readonly campaignRepository: CampaignRepository,
    ) {}

    async execute(
        pagination: Pagination,
        campaignFilter?: CampaignFilter,
    ): Promise<Campaigns> {
        const campaignResult = await this.campaignRepository.getAll(
            pagination,
            campaignFilter,
        );

        if (campaignResult.isErr()) {
            throw new Error("Error getting campaigns");
        }

        return campaignResult.match(
            (campaigns) => campaigns,
            () => Campaigns.empty(),
        );
    }
}
